module.exports = "/images/logo-crisis24.svg?908a6d3f413830582ffcc4613e6b5659";